import React from "react";
import { useHistory } from "react-router";
import useGetCh from "../../../hooks/useGetCh";
import useQuery from "../../../hooks/useQuery";
import { reportUserBehavior } from "../../../utils/common";
import styles from "./index.module.scss";
export default function () {
  document.title = "小鹏售后服务协议";
  const ch = useGetCh();
  const history = useHistory();
  const query = useQuery();
  // 获取路由query参数
  const aroundCheckOrderNo = query.get("aroundCheckOrderNo");
  const repairOrderCode = query.get("repairOrderCode");

  const handleAutograph = () => {
    if (aroundCheckOrderNo) {
      history.replace(
        `/serviceOrders/orderDetail/signatureTemplate?orderNo=${aroundCheckOrderNo}&orderType=aroundCheckOrder`
      );
    }
    if (repairOrderCode) {
      history.replace(
        `/serviceOrders/orderDetail/signatureTemplate?orderNo=${repairOrderCode}&orderType=repairOrder`
      );
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>小鹏售后服务协议</h1>
      <div className={styles.info}>
        1.在本文件上所签署客户，将被视为有权或已被授权向小鹏提出有关维修要求并同意小鹏进行相关的检查、维修（包括必要时对车辆相关部位进行拆解）、及有需要时进行路试。该客户对由此产生的费用负有全额支付的义务。
      </div>
      <div className={styles.info}>
        2.客户应对车辆权属及现状、相关车辆登记证照、保险资料的真实性、合法性和准确性负责。
      </div>
      <div className={styles.info}>
        3.由小鹏所提供报价或估计完工时间等，仅作为参考而不构成小鹏汽车对客户的任何承诺或保证。最终结算时按小鹏报价工时费、材料明细表等实际发生的金额结算。小鹏报价可能会因在实际施工过程的具体情况而出现事先无法预知的价格变动，当出现或可能出现这种价格变动时，小鹏将另行通知客户，敬请谅解。
      </div>
      <div className={styles.info}>
        4.维修期间，若小鹏汽车发现需增加维修项目或更换零配件的，小鹏汽车将会通知客户并且在征得客户同意后进行施工或更换，当无法联络客户或有关代表以获取明确指示时，小鹏将不会单方面进行该项维修，而仅在事先确认范围内进行维修。
      </div>
      <div className={styles.info}>
        5.在取得客户的同意后，小鹏汽车可能会使用非原厂配件进行维修。非原厂配件包括质量相当配件和原厂再制造零件，质量相当配件指非小鹏汽车提供或认可的，性能和质量达到小鹏汽车配件相关技术标准要求的零部件；原厂再制造零件指小鹏汽车供应的，与小鹏汽车原厂零件同等质量的原厂再制造零件。
      </div>
      <div className={styles.info}>
        6.经由小鹏检验后之车辆，如客户决定不再维修或未完成维修客户要求提车的，小鹏汽车将会按店内相关标准收取已经实际发生的检验/维修/保养费用。
      </div>
      <div className={styles.info}>
        7.客户对小鹏之服务如有异议或其他不满意时，须于取车时当面向小鹏负责人提出，对于车辆交接后提出的非维修质量问题的投诉（如车辆剐蹭等）小鹏将不予受理。
      </div>
      <div className={styles.info}>
        8.车辆检测/维修/保养完毕，或者车辆检测/维修/保养尚未完毕但是客户要求停止检测/维修/保养或要求提车的，小鹏汽车将会通知客户办理结算和提车手续。
      </div>
      <div className={styles.info}>
        9.由客户委托小鹏进行检验、保养或维修之车辆，如客户在收到小鹏汽车的维修通知、完工通知或其他类似通知两天后未有明确表示同意进行维修、保养，或未在约定日期到店取车时，小鹏有权按有关标准收取停车费或将车辆转移到正规停车场停放，由此产生的一切费用及责任由客户自行承担。
      </div>
      <div className={styles.info}>
        10.在客户尚未全部付清应付费用的情况下，小鹏有权对其车辆行使留置权；当小鹏向客户以书面或电话方式发出提车通知后，超过6个月而顾客仍未到店取车并付清全部费用，则小鹏有权处置该车辆。
      </div>
      <div className={styles.info}>
        11.客户将车辆交给小鹏时，应自行清点并取走车内的所有贵重物品，请勿遗留贵重物品在车内，如：金钱、手机、有价证券、重要资料的存储介质等。小鹏有权拒绝客户提出的任何财物遗失或类似的索赔主张。客户签署本协议将被视为已清点并取走自己的财物；客户签署结算单将被视为已对接收之车辆及车上物品查验清楚并无异议。
      </div>
      <div className={styles.info}>
        12.小鹏将会尽一切能力提供高水准的服务给予客户。但对于因政府行为、非小鹏责任导致的交通事故、火灾、水灾、冰雹、暴乱或任何非小鹏能力范围所能控制之情况下所引起对客户车辆或车内物件造成的损坏或损失，小鹏将不会承担任何违约或赔偿责任。
      </div>
      <div className={styles.info}>
        13.小鹏将不会在任何情况下负责赔偿车辆或车内物件在小鹏店内或在小鹏控制范围内，或在交收车辆途中发生的损失。除非该损失被证实是因为小鹏雇员的故意行为或疏忽所造成。
      </div>
      <div className={styles.info}>
        14.因客户原因造成车辆损坏（如交通事故等），客户应自行向责任方追讨或与自己的保险公司协商保险赔偿事宜，小鹏汽车将不会代客户进行上述索赔事宜的处理；客户不得因自己未获得赔偿或以赔偿事宜未得到解决为由而不向小鹏支付应付的任何费用(但双方另有书面约定的除外）。
      </div>
      <div className={styles.info}>
        15.由进行检验、维修、路试或交收车辆时产生的电能消耗，由客户自行承担。
      </div>
      <div className={styles.info}>
        16.如客户自带零配件或物料，小鹏有权不给予任何折扣，且对客户自带零配件或物料将不给予任何质量保证。
      </div>
      <div className={styles.info}>
        17.在小鹏进行车辆维修、道路检测、交收车途中时，如非小鹏雇员的故意行为或无证驾驶而发生的交通意外，客户须协助小鹏按保险理赔流程维修车辆，保险理赔未能赔偿部分，以修复车辆为共同目的双方协商处理。
      </div>
      <div className={styles.info}>
        18.本协议下如涉及到相关事项需要通知客户的，小鹏汽车将可能通过当面口头、电话、书面的方式通知，书面方式包括微信、短信、小鹏汽车APP消息推送、邮件、快递等方式。客户需提供有效的联系方式（微信、电话、APP账号、邮箱、地址）并有义务确保联系方式畅通，如因联系方式不正确/畅通导致无法及时联系客户造成的时间延误，应从维修时间中扣除。
      </div>

      <div
        className={styles.buttonWrapper}
        onClick={() => {
          handleAutograph();
          reportUserBehavior(
            {
              so: "J001002",
              mcode: "signature_agreement_to_sign",
              ch,
              pa: repairOrderCode
                ? `repairOrderCode=${repairOrderCode}`
                : `aroundCheckOrderNo=${aroundCheckOrderNo}`,
            },
            "event"
          );
        }}
      >
        <div className={styles.button}>
          <div className={styles.agree}>同意</div>
        </div>
      </div>
    </div>
  );
}
